import { useEffect } from "react";

/**
 * ARC-14 — browser unload guard.
 *
 * While `dirty` is true, a reload / tab close / back-navigation raises the
 * browser's own "leave site?" prompt. Browsers ignore custom text here, so the
 * message is only a legacy fallback; the guard is the `preventDefault()`.
 *
 * In-app tab changes cannot be caught from here — the shell owns navigation —
 * so FinancialDashboard guards those separately.
 */
const useUnsavedChangesGuard = (dirty, message = "You have unsaved expense changes.") => {
  useEffect(() => {
    if (!dirty) return undefined;

    const handler = (event) => {
      event.preventDefault();
      // Legacy Chrome/Safari still read returnValue; modern browsers show their own copy.
      event.returnValue = message;
      return message;
    };

    window.addEventListener("beforeunload", handler);
    return () => window.removeEventListener("beforeunload", handler);
  }, [dirty, message]);
};

export default useUnsavedChangesGuard;
